import { StatusReportStatusClient, SimpleStatusRequestUpdateSimpleStatusRequestItems, StatusReportStatusResponse } from 'services/tenantManagementService';
import { getTenantId } from 'features/Tenant/tenantUtils';
import store from 'base/reducer/store';
import { tryCatchJsonByAction } from 'utils/fetchUtils';
import { FetchingActionType, PersistItemsActionType } from 'features/Persist/actionTypes';

export const getCommunicationStatusesAction = () => {
	const tenantId = getTenantId()!;
	const client = new StatusReportStatusClient();
	return client.getAll(tenantId);
}

export const updateCommunicationStatusesAction = (model: SimpleStatusRequestUpdateSimpleStatusRequestItems) => {
	const tenantId = getTenantId()!;
	const client = new StatusReportStatusClient();
	return client.update(tenantId, model);
}

export const persistCommunicationStatusesAction = async () => {
	const state = store.getState();

	if (state.persistedCommunicationStatusReport.fetching) {
		return;
	}

	store.dispatch(setFetchingAction(true));

	const response = await tryCatchJsonByAction(getCommunicationStatusesAction);
	if (response.success) {
		store.dispatch(setAction(response.items || []));
	} else {
		store.dispatch(setFetchingAction(false));
	}
}

// redux

export const STATUS_REPORT_FETCHING = 'STATUS_REPORT_FETCHING';
export const STATUS_REPORT_SET = 'STATUS_REPORT_SET';

const setFetchingAction = (fetching: boolean): FetchingActionType => {
	return {
		type: STATUS_REPORT_FETCHING,
		fetching
	}
}

const setAction = (items: StatusReportStatusResponse[]): PersistItemsActionType<StatusReportStatusResponse> =>  {
	return {
		type: STATUS_REPORT_SET,
		items
	}
}

